export default __webpack_public_path__ + "static/right_back-725e9443bb33c72878dff18833fbf4c5.png";